import { useMutation } from '@apollo/client/react';

import { SecureUploadInitDocument } from 'src/graphql/actions/upload/secureUploadInit.mutation';
import { SecureUploadCompleteDocument } from 'src/graphql/actions/upload/completeSecureUpload.mutation';
import { SecureUploadCancelDocument } from 'src/graphql/actions/upload/secureUploadCancel.mutation';

import useSecureUploadFlow from './use-secure-upload-flow';

const useSecureUpload = (escrowId: string) => {
  const [initSecureUpload] = useMutation(SecureUploadInitDocument);
  const [completeSecureUpload] = useMutation(SecureUploadCompleteDocument);
  const [cancelSecureUpload] = useMutation(SecureUploadCancelDocument);

  return useSecureUploadFlow(escrowId, {
    init: async ({ numParts, filename }) => {
      const { data } = await initSecureUpload({
        variables: { softwareEscrowId: escrowId, numParts, filename },
      });

      return { uploadId: data?.secureUploadInit?.uploadId, uploadUrls: data?.secureUploadInit?.uploadUrls };
    },
    complete: ({ uploadId, filename, parts, size, contentType }) =>
      completeSecureUpload({
        variables: { softwareEscrowId: escrowId, uploadId, filename, parts, size, contentType },
      }),
    cancel: ({ uploadId }) => cancelSecureUpload({ variables: { softwareEscrowId: escrowId, uploadId } }),
  });
};

export default useSecureUpload;
